module.exports = __webpack_public_path__ + "static/img/IKEGAI.46c976a6.jpg";